import {createStore, compose, applyMiddleware} from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import rootReducer from '../reducers';
import {createEpicMiddleware} from 'redux-observable';
import rootEpic from '../epics';
import {REHYDRATE} from 'redux-persist/lib/constants';
import createActionBuffer from 'redux-action-buffer';
import logger from './transactionLogging';
import createWorkOrderMiddleware from './workOrderMiddleware';
import createQueueItemMiddleware from './queueItemMiddleware';
import {createMonitoringMiddleware} from './monitoringMiddleware';
import {persistStore} from 'redux-persist-immutable';
import userManager from '../utils/userManager';
import createOidcMiddleware from 'redux-oidc';
import {createTokenMiddleware} from './tokenMiddleware';
import pubnubMiddleware from './pubnubMiddleware';
import orderCloseMiddleware from './orderCloseMiddleware';
import localForage from 'localforage';
import {composeWithDevTools} from 'redux-devtools-extension/logOnlyInProduction';

const oidcMiddleware = createOidcMiddleware(userManager);
const epicMiddleware = createEpicMiddleware(rootEpic);
const workOrderMiddleware = createWorkOrderMiddleware();
const queueItemMiddleware = createQueueItemMiddleware();
const monitoringMiddleware = createMonitoringMiddleware({techRouteExpireMinutes: 60, techStatusExpireMinutes: 60, techStatusChangeTimeoutSeconds: 30});

const reduxPersistStore = localForage.createInstance({name: "app_store"});

const reduxPersistConfig = {
    blacklist: [
        'oidc', 'toastr', 'user'
    ],
    storage: reduxPersistStore
};

const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
});

export function configureStoreProd(initialState) {
    const middlewares = [
        logger,
        oidcMiddleware,
        createTokenMiddleware(),
        pubnubMiddleware,
        epicMiddleware,
        createActionBuffer(REHYDRATE),
        workOrderMiddleware,
        monitoringMiddleware,
        queueItemMiddleware,
        orderCloseMiddleware

    ];

    const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
    persistStore(store, reduxPersistConfig);

    return store;
}

export function configureStoreDev(initialState) {
    const middlewares = [
        reduxImmutableStateInvariant(),
        logger,
        oidcMiddleware,
        createTokenMiddleware(),
        pubnubMiddleware,
        epicMiddleware,
        createActionBuffer(REHYDRATE),
        workOrderMiddleware,
        monitoringMiddleware,
        queueItemMiddleware,
        orderCloseMiddleware
    ];

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
    const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module
            .hot
            .accept('../reducers', () => {
                const nextReducer = require('../reducers').default; // eslint-disable-line global-require
                store.replaceReducer(nextReducer);

            });

        module
            .hot
            .accept('../epics', () => {
                const rootEpic = require('../epics').default;
                epicMiddleware.replaceEpic(rootEpic);

            });

    }

    persistStore(store, reduxPersistConfig);

    return store;
}

// const configureStore = process.env.NODE_ENV === 'production'     ?
// configureStoreProd     : configureStoreDev;

export default configureStoreProd;


// WEBPACK FOOTER //
// ./src/store/configureStore.js